module.exports = {
      id: "comm-women-usage",
      viewBox: "0 0 228.124 50.336",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-women",
      toString: function () {
        return this.url;
      }
    }